import React, { Fragment } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom'
import Services from '../../api/service'
import Header2 from '../../components/Header2/Header2';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import Seo from '../../components/Seo/Seo';
import icon from '../../images/icons/icon_check_3.svg'

const COMPANY = 'Krit Cloud Platforms Sdn Bhd';

const splitList = (items) => {
    const midpoint = Math.ceil(items.length / 2)
    return [items.slice(0, midpoint), items.slice(midpoint)]
}

const ChecklistColumns = ({ items }) => {
    const columns = splitList(items)

    return (
        <div className="row mb-4">
            {columns.map((column, columnIndex) => (
                <div className="col-lg-6" key={columnIndex}>
                    <ul className="icon_list unordered_list_block">
                        {column.map((item, index) => (
                            <li key={index}>
                                <span className="icon_list_icon">
                                    <img src={icon} alt="Check SVG Icon"/>
                                </span>
                                <span className="icon_list_text">
                                    {item}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    )
}

const ServiceSinglePage = () => {

    const { slug } = useParams()

    const ServiceDetails = Services.find(item => item.slug === slug)

    if (!ServiceDetails) {
        return <Navigate to="/service" replace />
    }
    const serviceContent = ServiceDetails.details || {
        overview: `${ServiceDetails.title} helps businesses improve daily operations with practical technology planning, implementation, and support.`,
        approach: 'We review the current workflow, identify priorities, and recommend a focused implementation plan that balances usability, security, and long-term maintainability.',
        outcomeIntro: 'The result is a clearer technology direction, better operational control, and a solution that supports measurable business improvement.'
    }
    const serviceOutcomes = ServiceDetails.outcomes || [
        'Scalability and flexibility',
        'Security and compliance',
        'Performance optimization',
        'User experience',
        'Process efficiency',
        'Training and education'
    ]
    const fallbackSeoContent = {
        title: `${ServiceDetails.title} Malaysia | Krit Cloud Platforms`,
        metaDescription: `${ServiceDetails.title} services by ${COMPANY} for businesses in Malaysia.`,
        keywords: [ServiceDetails.title, 'IT Services Malaysia', 'Digital Transformation Malaysia'],
        ogTitle: `${ServiceDetails.title} Malaysia | Krit Cloud Platforms`,
        ogDescription: `${ServiceDetails.title} services by ${COMPANY} for businesses in Malaysia.`,
        h1: `${ServiceDetails.title} in Malaysia`,
        heroIntro: ServiceDetails.description || serviceContent.overview,
        ctaLabel: 'Talk to an Expert',
        overview: serviceContent.overview,
        services: ServiceDetails.features || ['Consulting', 'Planning', 'Development', 'Deployment', 'Support', 'Maintenance'],
        benefits: serviceOutcomes,
        process: ['Discovery and consultation', 'Solution planning', 'Implementation', 'Testing and validation', 'Support and improvement'],
        technologies: ['React.js', 'Node.js', 'Azure', 'AWS', 'SQL Server', 'Power BI'],
        industries: ['Healthcare', 'Logistics', 'Manufacturing', 'Retail', 'Finance', 'Education', 'Government', 'SMEs', 'Startups'],
        faqs: [
            {
                question: `What is ${ServiceDetails.title}?`,
                answer: serviceContent.overview,
            },
            {
                question: 'Do you provide ongoing maintenance?',
                answer: `Yes. ${COMPANY} provides support, maintenance and continuous improvement after implementation.`,
            },
        ],
        internalLinks: [],
        imageAlt: `${ServiceDetails.title} by ${COMPANY}`,
        imageTitle: `${ServiceDetails.title} services in Malaysia`,
    }
    const seoContent = ServiceDetails.seoContent || fallbackSeoContent

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const serviceHighlights = [
        'Business-focused discovery',
        'Secure implementation',
        'Long-term support',
    ]

    return (
        <Fragment>
            <Seo
                title={seoContent.title}
                description={seoContent.metaDescription}
                keywords={seoContent.keywords}
                ogTitle={seoContent.ogTitle}
                ogDescription={seoContent.ogDescription}
            />
            <Header2 />
            <main className="page_content service-single-page">
                <PageTitle pageTitle={ServiceDetails.title} pagesub={'Details'} pageTop={'Services'} />
                <section className="service_details_section section_space bg-light">
                    <div className="container">
                        <div className="service_summary_panel">
                            <div className="service_summary_content">
                                <span className="service_summary_label">Service Overview</span>
                                <p>{seoContent.heroIntro}</p>
                                <Link onClick={ClickHandler} to="/contact" className="btn">
                                    <span className="btn_label" data-text={seoContent.ctaLabel}>{seoContent.ctaLabel}</span>
                                    <span className="btn_icon">
                                        <i className="fa-solid fa-arrow-up-right"></i>
                                    </span>
                                </Link>
                            </div>
                            <div className="service_summary_meta">
                                {serviceHighlights.map((highlight) => (
                                    <div className="service_summary_meta_item" key={highlight}>
                                        <span className="icon_list_icon">
                                            <img src={icon} alt="" />
                                        </span>
                                        <span>{highlight}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <h2 className="details_item_title">Overview</h2>
                        <p>{seoContent.overview}</p>

                        <h2 className="details_item_info_title">Our Services</h2>
                        <ChecklistColumns items={seoContent.services || fallbackSeoContent.services} />

                        <h2 className="details_item_info_title">Benefits</h2>
                        <ChecklistColumns items={seoContent.benefits || serviceOutcomes} />

                        <h2 className="details_item_info_title">Our Process</h2>
                        <p>{serviceContent.approach}</p>
                        <ChecklistColumns items={seoContent.process || fallbackSeoContent.process} />

                        <h2 className="details_item_info_title">Why Choose Krit Cloud Platforms Sdn Bhd</h2>
                        <p>
                            {COMPANY} combines an experienced team, modern technologies, agile development, quality assurance and long-term support. We focus on customer needs first, then design secure and maintainable solutions that fit real business operations in Malaysia.
                        </p>

                        <h2 className="details_item_info_title">Technologies</h2>
                        <div className="service_seo_pills mb-4">
                            {(seoContent.technologies || fallbackSeoContent.technologies).map((technology, item) => (
                                <span className="service_seo_pill" key={item}>{technology}</span>
                            ))}
                        </div>

                        <h2 className="details_item_info_title">Industries We Serve</h2>
                        <ChecklistColumns items={seoContent.industries || fallbackSeoContent.industries} />

                        <h2 className="details_item_info_title">FAQ</h2>
                        <div className="service_faq_list">
                            {(seoContent.faqs || fallbackSeoContent.faqs).map((faq, item) => (
                                <div className="service_faq_item" key={item}>
                                    <h3>{faq.question}</h3>
                                    <p>{faq.answer}</p>
                                </div>
                            ))}
                        </div>

                        {seoContent.internalLinks && seoContent.internalLinks.length > 0 && (
                            <Fragment>
                                <h2 className="details_item_info_title">Related Services</h2>
                                <div className="service_seo_pills mb-5">
                                    {seoContent.internalLinks.map((link, item) => (
                                        <Link onClick={ClickHandler} to={`/service/${link.slug}`} className="service_seo_pill" key={item}>{link.label}</Link>
                                    ))}
                                </div>
                            </Fragment>
                        )}

                        <h2 className="details_item_info_title">Service Outcomes</h2>
                        <p className="mb-4">{serviceContent.outcomeIntro}</p>
                        <ChecklistColumns items={serviceOutcomes} />

                        <div className="service_final_cta">
                            <h2 className="details_item_info_title">Ready to transform your business?</h2>
                            <p>Contact Krit Cloud Platforms Sdn Bhd today for a free consultation.</p>
                            <Link onClick={ClickHandler} to="/contact" className="btn">
                                <span className="btn_label" data-text="Free Consultation">Free Consultation</span>
                                <span className="btn_icon">
                                    <i className="fa-solid fa-arrow-up-right"></i>
                                </span>
                            </Link>
                        </div>

                    </div>
                </section>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServiceSinglePage;
